import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
  import { UserModule } from '@/store/modules/user'
  import { DateTime } from 'luxon'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'IDDMinutesWidget',
  setup(__props) {

  const iddMinutesCounter = computed(() => UserModule.currentIddMinutesCount)

  const currentYear = computed(() => DateTime.now().year)

return { __sfc: true,iddMinutesCounter, currentYear, computed, UserModule, DateTime }
}

})